import _ from 'lodash';
import { Reducer } from 'redux';
import { RecentClientsState } from '../../../type-definitions/redux-declarations';
import {
	RecentClientsAction,
	RecentClientsActionTypes,
} from '../../actions/recent-clients.actions';
import { SearchDataItem } from '../../../logic/domains/search.domain';
import formatAsUpperFirst from '../../../logic/functions/common/formatAsUpperFirst';

const initialState: RecentClientsState = {
	items: [],
	loading: true,
	error: false,
};

const reducer: Reducer<RecentClientsState, RecentClientsAction> = (
	state = initialState,
	action: RecentClientsAction
): RecentClientsState => {
	switch (action.type) {
		case RecentClientsActionTypes.RECENT_CLIENTS_RESULTS_SUCCESS: {
			return {
				...state,
				items: formatRecentClients(action.response),
				loading: false,
			};
		}

		case RecentClientsActionTypes.RECENT_CLIENTS_RESULTS_FAILURE: {
			return {
				...state,
				items: [],
				error: true,
				loading: false,
			};
		}
		case RecentClientsActionTypes.RECENT_CLIENTS_RESULTS_LOADING: {
			return {
				...state,
				loading: true,
			};
		}

		default: {
			return state;
		}
	}
};

const formatRecentClients = (recentClients?: any): Array<SearchDataItem> => {
	if (recentClients) {
		const recentClientsList: Array<SearchDataItem> = [];
		recentClients.forEach((client: any) => {
			recentClientsList.push({
				id: client.id,
				type: client.type === 'C' ? 'client' : 'plan',
				name: formatAsUpperFirst(client.displayName),
				token: client.token,
			});
		});

		return recentClientsList;
	}
	return [];
};

export { initialState, reducer as recentClientsReducer };
